import React from "react";

const ModelFilter = ({ type, onClick, isHidden = false }) => {
  let colorBackground =
    "bg-color-background-secondary dark:bg-color-dark-background-secondary";
  let border = "border";
  let borderColor =
    "border-color-border-secondary dark:border-color-dark-border-secondary";
  let title = "Model";

  if (type === "ACCOUNT_PLAN_EXECUTION") {
    borderColor =
      "dark:border-color-dark-model-account-plan-execution border-color-model-account-plan-execution";
    title = "Account Plan Execution";
  }
  if (type === "ACCOUNT_PLAN") {
    borderColor =
      "dark:border-color-dark-model-account-plan border-color-model-account-plan";
    title = "Account Plan";
  }
  if (type === "PAYMENT_METHOD") {
    borderColor =
      "dark:border-color-dark-model-payment-method border-color-model-payment-method";
    title = "Payment Method";
  }
  if (type === "USER_PII") {
    borderColor =
      "dark:border-color-dark-model-user-pii border-color-model-user-pii";
    title = "User PII";
  }
  if (type === "NOTE") {
    borderColor = "dark:border-color-dark-model-note border-color-model-note";
    title = "Note";
  }
  if (type === "ORGANISATION_TRANSFER") {
    borderColor =
      "dark:border-color-dark-model-organisation-transfer border-color-model-organisation-transfer";
    title = "Organisation Transfer";
  }
  if (type === "ORGANISATION_ACTIVITY") {
    borderColor =
      "dark:border-color-dark-model-organisation-activity border-color-model-organisation-activity";
    title = "Organisation Activity";
  }
  if (type === "USER_STATUS") {
    borderColor =
      "dark:border-color-dark-model-user-status border-color-model-user-status";
    title = "Account User Status";
  }

  if (!isHidden) {
    border = border + " border border-l-[5px]";
  } else {
    borderColor =
      "border-color-border-secondary dark:border-color-dark-border-secondary";
  }

  return (
    <div
      className={`flex flex-col items-center justify-center font-semibold  px-2 py-1 text-xs rounded-md cursor-pointer hover:scale-95 active:scale-90 transition-all select-none ${colorBackground} ${border} ${borderColor}`}
      onClick={onClick}
    >
      {title}
    </div>
  );
};

export default ModelFilter;
